export { ResourceLink } from './ResourceLink';
export { ResourceType } from './resourceLink.types';
